/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { MyClaimsDetail, MyClaimsConversion } from "../components";
import { Wrapper } from "../HOC";
import { MdSend, MdOutlineEmail, MdMessage } from "react-icons/md";
import { AiFillAudio, AiFillVideoCamera } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useVault } from "../context/VaultContext";
import LoadingModal from "../components/Loader/LoadingModal";
import EmptyContent from "../components/Popups/EmptyContent";
import { serverTimestamp } from "firebase/firestore";
import { auth } from "../firebase/firebase";
import { useDispatch } from "react-redux";
import { closeModal, openModal } from "../redux/modal/modalRedux";
import useUploadDocument from "../hooks/useUploadDoc";
import VoiceRecorder from "../components/Media/VoiceRecorder";

const MyClaims = () => {
  const { claims, addclaimnote, setLoading, getclaimnotes, claimnotes, setSelectedClaim, selectedClaim, noteLoader } = useVault();
  const inputRef = React.useRef(null);
  const dispatch = useDispatch();
  const [content, setContent] = useState("");
  const [filteredClaims, setFilteredClaims] = useState([]);
  const [ sortYear, setSortYear ] = useState();
  const { onChange, doc, setUrl, onNewDoc } = useUploadDocument();

  

  useEffect(() => {
    if (sortYear && sortYear !== ''){
      const claimArr = claims;
      const filterClaims = claims.filter((cm) => cm?.dateOfLoss.toString().includes(sortYear) || cm?.dateOfClaim.toString().includes(sortYear));
      
      filterClaims.forEach((element, index) => {
        claimArr.splice(0, 0, claimArr.splice(index, 1)[0]);
      });

      setFilteredClaims(claimArr);
    }else{
      setFilteredClaims(claims);
    }
  }, [claims, sortYear])

  const handleSend = () => {
    const value = inputRef.current.value;
    setContent(value);
    addNewNote("message",value)
    inputRef.current.value = "";
  };
  
  const addNewNote = (type, value) => {
    addclaimnote({ note: value, type: type, claimName: selectedClaim?.claimName, createdAt: serverTimestamp() });
  }
  
  useEffect(() => {
    if (auth?.currentUser?.uid) {
    
    }
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  const addMediaFile = (e) => {
    let mediaType;
    let type
    if(e.files){
      mediaType = e.target.files[0].type;
      type = mediaType.split("/")[0];
      onChange(e, 'claim', setLoading);
    }else{
      mediaType = e.type;
      type = mediaType.split("/")[0];
      onNewDoc(e, 'claim', setLoading)
    }
    addNewNote(type, doc.url)
    setUrl(null);
  }

  useEffect(() => {
    selectedClaim?.claimName && getclaimnotes(selectedClaim?.claimName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClaim?.claimName]);

  useEffect(() => {
    if (noteLoader) {
      dispatch(openModal());
    } else {
      dispatch(closeModal());
    }
  }, [dispatch, noteLoader]);

  return (
    <Wrapper>
      <LoadingModal />
      <div className="pb-5 w-full">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <p className="font-bold text-2xl pr-5">Year {new Date().getFullYear()}</p>
            <Link to="/claims/addclaim">
              <button className="border-2 border-primary text-primary text-sm rounded-lg py-2 px-7 font-medium hover:bg-primary hover:text-white">
                Add New
              </button>
            </Link>
          </div>
          <div className="flex items-center">
            <p className="font-medium text-sm pr-5">Sort by year</p>
            <select onChange={(e) => {
              setSortYear(e.target.value);
            }} className="border-2 border-primary text-primary bg-white text-sm font-semibold rounded-lg py-2 px-7 focus:outline-none">
              <option value="2022">2022</option>
              <option value="2021">2021</option>
              <option value="2020">2020</option>
            </select>
          </div>
        </div>

        <div className="flex justify-between items-start w-full">
          <div className="w-[38%]">
            {filteredClaims?.length > 0 ? filteredClaims?.map((item, key) => <MyClaimsDetail key={key} item={item} />) : <EmptyContent />}
          </div>

          <div className="w-[60%] border-2 rounded-xl mt-3 max-h-[700px] overflow-scroll relative">
            <p className="font-medium border-b-2 py-5 mb-10 px-5 w-full ">Claim Notes</p>
            {/* <p className="text-xs border-2 rounded-xl p-4 mb-3 mx-5">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
              sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
              ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
              dolore magna aliquyam erat, sed diam voluptua. At vero
            </p>

            <div className="border-b-2 pb-1 px-5">
              <MyClaimsConversion message />
              <MyClaimsConversion audio />
              <MyClaimsConversion video />
            </div> */}

            {claimnotes?.length > 0 ? (
              claimnotes?.map((item, key) => {
                return (
                  <div className="mb-4" key={key}>
                    {item?.type === "message" ? (
                      <p className="text-xs border-2 rounded-xl p-4 mb-2 mx-5">{item?.note}</p>
                      ) : (
                        <MyClaimsConversion key={key} item={item} note={item?.note} type={item?.type} />
                    )}
                    <p className="text-[10px] mx-5">
                      {item?.date ? JSON.stringify(item?.date?.toDate()).replace(/['"]+/g, "") : new Date().toISOString()}
                    </p>
                  </div>
                );
              })
            ) : (
              <div className="flex justify-center items-center h-96">
                <p className="text-center text-gray-400">No notes found</p>
              </div>
            )}
            <div className="flex items-center justify-between px-5 py-2 border-t-1 w-full sticky bottom-0 bg-white z-100">
              <div className="flex items-center justify-between border-2 border-primary px-2 py-1 w-full rounded-lg">
                <input
                  ref={inputRef}
                  type="text"
                  placeholder="Write a New Note"
                  className="w-[90%] focus:outline-none"
                  onKeyDown={(e) => {
                    if (e.code === "Enter") {
                      handleSend();
                    }
                  }}
                />
                <div className="bg-[#f5f5f5] p-2 pl-3 rounded-md cursor-pointer">
                  <MdSend className="text-primary" onClick={handleSend} />
                </div>
              </div>
              <div className="flex items-center w-[35%]">
                <div className="flex flex-col items-center justify-center pl-2">
                  <VoiceRecorder onRecorded={addMediaFile} />
                  <p className="text-[7px] text-primary font-medium">Record Audio</p>
                </div>
                <div className="flex flex-col items-center justify-center  pl-2">
                  <div className="p-[5px] rounded-full text-primary border-2 border-primary text-xl cursor-pointer">
                    <label htmlFor='mediaUpload' className="cursor-pointer">
                      <AiFillVideoCamera />
                    </label>
                    <input
                      id="mediaUpload"
                      type="file"
                      accept="image/*, video/*"
                      className="w-0.1 h-0.1 overflow-hidden hidden"
                      onChange={addMediaFile}
                    />
                  </div>
                  <p className="text-[7px] text-primary font-medium">Add Video</p>
                </div>
                <div className="flex flex-col items-center justify-center pl-2">
                  <div className="p-[5px] rounded-full text-primary border-2 border-primary text-xl cursor-pointer">
                    <MdOutlineEmail />
                  </div>
                  <p className="text-[7px] text-primary font-medium">Send Email</p>
                </div>
                <div className="flex flex-col items-center justify-center pl-2">
                  <div className="p-[5px] rounded-full text-primary border-2 border-primary text-xl cursor-pointer">
                    <MdMessage />
                  </div>
                  <p className="text-[7px] text-primary font-medium">Send SMS</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default MyClaims;
